/* =========================================================================
   et-lang-redirect.js - Ela Teila
   KALBA PAGAL SALI: lankytojas is Lietuvos -> lietuviska versija (/lt),
   is kitu saliu -> lieka angliska.

   Kraunama is snippets/et-scroll-keep.liquid (pirma eilute, kuo anksciau).
   GRAZINIMAS: istrinti ta <script> eilute snippete.

   KAIP VEIKIA
   - Sali nustato pats Shopify (/browsing_context_suggestions.json).
   - Tikrinama TIK karta narsyklei. Po to issaugoma zyme et_lang_checked
     (localStorage + slapukas 1 metams). Jei zmogus po to pats pasirenka EN,
     jo nebeperjungiam.
   - Atejus tiesiai i /lt puslapi zyme irgi uzdedama - perjungus i EN, liks EN.
   - Nelieciama: Shopify redaktorius (design_mode isjungtas liquid'e), robotai
     (Google ir kt.), /checkouts, /account, /apps, /services, /cdn.
   2026-10-15 (Rita patvirtino: is LT - LT, is kitur - anglu).
   ========================================================================= */
(function () {
  var KEY = 'et_lang_checked';

  function seen() {
    try { if (localStorage.getItem(KEY)) return true; } catch (e) {}
    return document.cookie.indexOf(KEY + '=1') !== -1;
  }
  function mark() {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    try { document.cookie = KEY + '=1; path=/; max-age=31536000; samesite=lax'; } catch (e) {}
  }

  try {
    var path = location.pathname;
    if (/^\/lt(\/|$)/.test(path)) { mark(); return; }
    if (seen()) return;
    if (/bot|crawl|spider|slurp|lighthouse|headless|preview/i.test(navigator.userAgent || '')) return;
    if (/^\/(checkouts|account|apps|services|cdn|admin)(\/|$)/.test(path)) return;
    if (!window.fetch) return;

    fetch('/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=&language[enabled]=true&language[exclude]=', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        mark();
        if (c === 'LT') {
          location.replace('/lt' + (path === '/' ? '' : path) + location.search + location.hash);
        }
      })
      .catch(function () {});
  } catch (e) {}
})();
